var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dimension-filter-condition-editor",class:{ 'border-l': _vm.depth > 0 },style:({ borderColor: _vm.colorByPrevDepth })},[_c('TypeSelector',_vm._b({attrs:{"object-type":"Dimension Filter Condition","context":{
      dimensionValues: _vm.dimensionValues,
      loadingValues: _vm.loadingValues,
    },"type-options":_vm.conditionTypes},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}},'TypeSelector',_vm.subObjectBinds,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }